<template>
  <div id="host-update" class="row" v-if="detail.id !== ''">
    <form id="update-host-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">

      <label>
        {{ 'IP addresses'|t }}
        <textarea v-model="ips" rows="5"></textarea>
      </label>

      <fieldset class="fieldset">
        <legend>{{ 'Statuses'|t }}</legend>
        <label v-for="s in getStatusList()">
          <input type="checkbox" v-model="statuses" :value="s" />
          {{ s }}
        </label>
      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';
  import i18n from '@/plugins/i18n';

  export default {
    name: 'UpdateForm',
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        detail: {
          id: ""
        },
        ips: "",
        statuses: []
      }
    },
    created() {
      api.viewHost(
        {host_name: this.name},
        data => {
          this.detail = data;

          let ips = data.ips || [];
          this.ips = ips.join("\n");

          this.statuses = data.status;

          let title = this.pageTitle;
          title += " " + this.name;
          this.$store.commit("setPageTitle", title)
        }
      )
    },
    computed: {
      pageTitle() {
        return this.$store.getters['pageTitle']
      },
    },
    methods: {
      submitForm() {
        let request = {
          host_name: this.name,
          ip_add: [],
          ip_remove: [],
          status_add: [],
          status_remove: []
        };

        let ips = this.ips.split("\n").filter(word => word.length > 0);
        for (let i in this.detail.ips) {
          if (ips.indexOf(this.detail.ips[i]) === -1) {
            request.ip_remove.push(this.detail.ips[i]);
          }
        }
        for (let i in ips) {
          if (this.detail.ips.indexOf(ips[i]) === -1) {
            request.ip_add.push(ips[i]);
          }
        }

        for (let i in this.detail.status) {
          if (this.statuses.indexOf(this.detail.status[i]) === -1) {
            request.status_remove.push(this.detail.status[i]);
          }
        }
        for (let i in this.statuses) {
          if (this.detail.status.indexOf(this.statuses[i]) === -1) {
            request.status_add.push(this.statuses[i]);
          }
        }

        api.updateHost(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Host %s has been updated.",
              args: [data.name]
            }, {root: true});
            router.push({name: 'host.collection'});
          }
        );
      },
      getStatusList() {
        return ['clientUpdateProhibited', 'clientDeleteProhibited']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/host/UpdateForm.vue